<template>
	 <v-container>
		 <v-dialog title="新增课程" v-model="hideShow" width="500" persistent>
			<v-card>
				
				<v-card-title>
					<span>新增课程</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-alert v-if="modesError" type="error" dense>{{modesError}} <v-btn text small @click="loadModes">重试</v-btn></v-alert>
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="课程名称" v-model="add.courseName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12" class="d-flex">
							<v-select :items="consumeTypes" v-model="add.consumeType" :loading="modesLoading" :disabled="modesLoading || consumeTypes.length===1"
							item-text="typeText" item-value="typeValue" label="扣费方式" dense outlined></v-select>
							<a @click="desc.dialog=true" style="color:red; font-size:13px" class="ml-1 mt-2">扣费方式说明</a>
						</v-col>
						<v-col cols="12">
							<v-text-field type="number" label="标准课时单价" v-model="add.consumePrice" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAdd" :disabled="modesLoading || !!modesError" :loading="submiting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog title="扣费方式说明" v-model="desc.dialog" width="500">
			<v-card>
				<v-card-title>
					<span>扣费方式说明</span>
					<v-spacer></v-spacer>
					<v-icon @click="desc.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="d-flex flex-column pt-5">
					<div>
						<span style="color:red; font-weight: 500;">按课时扣费</span>
						<span>:学员报名该课程会产生该课程的课时账户，每次上课会扣除该课程账户的课时数。如果学员报名2门扣课时的课程，会分别产生这2个课程的课时账户，需要分别缴费充值。</span>
					</div>
					
					<div class="mt-2">
						<span style="color:red; font-weight: 500;">按金额扣费</span>
						<span>: 学员只有一个金额账户，所有扣金额模式的课程都从这个金额账户扣费。如果学员报名2门扣金额的课程，都从同一个金额账户扣款。</span>
					</div>
				
					<div style="color:red" class="mt-2">请根据校区的实际运营模式选择</div>
					
				</v-card-text>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import {fetchAccountModes,consumeOptions} from '../config/accountModes'
	import utils from "../config/utils"
	export default {
		name:"create-room",
		
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
 if(newVal)this.loadModes();
			},
			
		},
		data(){
			this.submitAdd = utils.throttle(this.submitAdd, 500)
			return {
				desc:{
					dialog:false,
					title:"",
					content:""
					
				},
				consumeTypes:[],
 modesLoading:false, modesError:"", modeShopId:"", modesRequest:0,
				add: {
					courseName:"",
					consumeType:"",
					consumePrice:""
				},
				hideShow:this.show,
				submiting:false,
			}
		},
		mounted() {
			if(this.show)this.loadModes();
		},
		beforeDestroy(){this.modesRequest++},
		methods:{
 async loadModes(){
  const seq=++this.modesRequest, shopId=utils.getCurrentShopId();this.modeShopId=String(shopId||"");this.consumeTypes=[];this.modesError="";this.modesLoading=true;
  try{const modes=await fetchAccountModes(this.axios,shopId);if(seq!==this.modesRequest)return;this.consumeTypes=consumeOptions.filter(x=>modes.includes(x.typeValue));if(!modes.includes(this.add.consumeType))this.add.consumeType=modes.length===1?modes[0]:""}
  catch(e){if(seq===this.modesRequest)this.modesError=e.message}
  finally{if(seq===this.modesRequest)this.modesLoading=false}
 },
			// throttle (func, wait) {
			//   let timeout = null
			//   return function () {
			//       const context = this
			//       const args = arguments
			//       if (!timeout) {
			//           timeout = setTimeout(() => {
			//               timeout = null
			//               func.apply(context, args)
			//           }, wait)
			//       }
			//   }
			// },
			submitAdd(){		
				if(this.submiting||this.modesLoading)return;
 if(this.modeShopId!==String(utils.getCurrentShopId()||"")){this.$noty.error("校区已变化，请重新打开表单");return}
 if(!this.consumeTypes.some(x=>x.typeValue===this.add.consumeType)){this.$noty.error("请选择校区已启用的扣费方式");return}
				if (!this.add.courseName) {
					this.$noty.error('课程名称不能为空');
					return
				}
				if (!this.add.consumeType) {
					this.$noty.error('扣费方式不能为空');
					return
				}
				
				if (!this.add.consumePrice) {
					this.$noty.error('课时价格不能为空');
					return
				}
				this.submiting = true;
				
				const shopId = utils.getCurrentShopId();
				// api
				const that = this;
				let url = `/edu/course/create`;
				let postData = {...this.add};
				postData.shopId = shopId;
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							
							that.$emit("success","");
							that.submiting = false;
							return;
						} else {
							that.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.submiting = false;
						that.$noty.error('网络请求失败');
					}
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

<style>
</style>
